(() => {
  function enhanceHomeSections() {
    const collections = document.querySelector('.shopify-section[id*="collection_list_xciWEg"]');
    if (collections) {
      const header = collections.querySelector('.section-resource-list__content');
      if (header && !header.querySelector('.dj-aurelia-heading')) {
        header.innerHTML = '<div class="dj-aurelia-heading dj-aurelia-heading--center"><p class="dj-aurelia-heading__eyebrow">COLLECTIONS</p><h2 class="dj-aurelia-heading__title">Nos catégories</h2></div>';
      }

      const descriptions = {
        'colliers': 'Colliers délicats et intemporels',
        'bracelets': 'Bracelets raffinés à porter au quotidien',
        'boucles-d-oreilles': 'Boucles élégantes et lumineuses'
      };

      collections.querySelectorAll('.collection-card').forEach((card) => {
        const link = card.querySelector('.collection-card__link');
        const href = link ? link.getAttribute('href') || '' : '';
        const handle = Object.keys(descriptions).find((key) => href.includes('/collections/' + key));
        const content = card.querySelector('.collection-card__content');
        if (handle && content && !content.querySelector('.dj-collection-card__description')) {
          const text = document.createElement('p');
          text.className = 'dj-collection-card__description';
          text.textContent = descriptions[handle];
          content.appendChild(text);
        }
      });
    }

    const upgradeProductHeader = (selector, eyebrow, title, fallbackHref = '/collections/all') => {
      const section = document.querySelector('.shopify-section[id*="' + selector + '"]');
      if (!section) return;
      const header = section.querySelector('.section-resource-list__header');
      if (!header || header.querySelector('.dj-aurelia-product-heading')) return;
      const currentLink = header.querySelector('a');
      const href = currentLink ? currentLink.getAttribute('href') || fallbackHref : fallbackHref;
      header.innerHTML = '<div class="dj-aurelia-product-heading"><p class="dj-aurelia-heading__eyebrow">' + eyebrow + '</p><div class="dj-aurelia-product-heading__row"><h2 class="dj-aurelia-heading__title">' + title + '</h2><a class="dj-aurelia-heading__link" href="' + href + '">Voir tout</a></div></div>';
    };

    upgradeProductHeader('product_list_themegen', 'SÉLECTION', 'La sélection Dar Jawhara', '/collections/la-selection-dar-jawhara');
    upgradeProductHeader('product_list_cAhEM3', 'NOUVEAUTÉS', 'Derniers ajouts', '/collections/derniers-ajouts');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceHomeSections, { once: true });
  } else {
    enhanceHomeSections();
  }
  document.addEventListener('shopify:section:load', enhanceHomeSections);
})();
